import BaseApi from '../base/base'
import SchoolSetting from '../../models/school_setting'

export default class SchoolSettingApi extends BaseApi {
  constructor() {
    super()
    this.path = '/school_settings'
  }

  async get(params = {}) {
    this.path = '/school_settings'
    const response = await this.getRequest(params)
    return new SchoolSetting(response.data)
  }
}
